export const ACCESS_TOKEN_MEDIA_TYPE = 'application/vnd.io.tunnr.api.access.token.v1+json';

export interface AccessTokenResponse {
  access_token: string,
  token_type: string
}
